import React, { Component } from "react";
import StripeCheckout from "react-stripe-checkout";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { STRIPE_PUBLISHABLE_KEY } from "../../environment";
import "./Offer.css";
import Dialog from "material-ui/Dialog";

class Offer extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      open: false,
      openEarlyAccess: false
    };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpenEarlyAccess = () => {
    this.setState({ openEarlyAccess: true });
  };

  handleCloseEarlyAccess = () => {
    this.setState({ openEarlyAccess: false });
  };

  login() {
    this.props.auth.login();
  }

  renderOffer() {
    const { project, offer, user } = this.props;
    const { early_access } = this.props.user;
    // inject project props into the offer
    offer.projectId = project.projectId;
    offer.projectTitle = project.title;
    offer.stripeDescription =
      project.charity[0].title +
      " - " +
      project.title +
      " - " +
      offer.description;
    const { isAuthenticated } = this.props.auth;
    switch (project.type) {
      case "volunteer":
        return (
          <a href={`mailto:${this.props.project.charity[0].email}`}>
            <div>
              <p className="offer-card-title">{offer.title}</p>
              <p className="offer-card-text">{offer.description}</p>
            </div>
          </a>
        );
      default:
        if (!isAuthenticated()) {
          return (
            <div onClick={this.handleOpen}>
              <p className="offer-card-title">{offer.title}</p>
              <p className="offer-card-text">{offer.description}</p>
            </div>
          );
        }
        // else if (!early_access) {
        //     return (
        //         <div onClick={this.handleOpenEarlyAccess}>
        //             <p className="offer-card-title">{offer.title}</p>
        //             <p className="offer-card-text">{offer.description}</p>
        //         </div>
        //     );
        // }
        else {
          return (
            <StripeCheckout
              name={offer.title}
              description={offer.stripeDescription}
              amount={offer.amount * 100}
              currency="AUD"
              email={user.email}
              token={token => this.props.createPayment(offer, token)}
              stripeKey={STRIPE_PUBLISHABLE_KEY}
            >
              <p className="offer-card-title">{offer.title}</p>
              <p className="offer-card-text">{offer.description}</p>
            </StripeCheckout>
          );
        }
    }
  }

  render() {
    return (
      <div className="offer-card tikki-shadow">
        <Dialog
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          bodyClassName="tikki-dialog"
        >
          <span className="tikki-paragraph">
            You must be signed in to donate.{" "}
            <a onClick={this.login.bind(this)}>Login</a>
          </span>
        </Dialog>
        {/* <Dialog
          modal={false}
          open={this.state.openEarlyAccess}
          onRequestClose={this.handleCloseEarlyAccess}
          bodyClassName="tikki-dialog"
        >
          <span className="tikki-paragraph">
            Unfortunately this feature is only available to our testers at this
            stage. We look forward to opening this up to you in the near future.
          </span>
        </Dialog> */}
        {this.renderOffer()}
      </div>
    );
  }
}

function mapStateToProps({ user }, ownProps) {
  return { user };
}

export default connect(
  mapStateToProps,
  actions
)(Offer);



// WEBPACK FOOTER //
// ./src/components/common/Offer.js